// extracted by mini-css-extract-plugin
module.exports = {"page":"SellPage_page__0hHa7"};